<script>
import BFormCheckboxRadio from '@/components/form/base/BFormCheckboxRadio'

export default {
  name: 'CFormRadio',

  extends: BFormCheckboxRadio,

  props: {
    modelValue: {
      type: [Array, Boolean, Date, Number, Object, String],
      default: ''
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: [Array, Boolean, Date, Number, Object, String],
      required: true
    }
  },

  data () {
    return {
      type: 'radio'
    }
  },

  computed: {
    checked () {
      return JSON.stringify(this.modelValue) === JSON.stringify(this.value)
    }
  },

  methods: {
    onChange (event) {
      this.$emit('change', this.value)
    }
  }
}
</script>
